<template>
    <div class="action-entries">
        <table class="kgr-row">
            <template
                v-for="attendance in attendances"
            >
                <kgr-member-attendance-time-edit-row
                    v-if="attendanceInEditMode === attendance.id"
                    :key="attendance.id"
                    :attendance-id="attendance.id"
                    :start="attendance.start"
                    :end="attendance.end"
                    :pending-attendances="pendingAttendances"
                    :is-editable="attendance.isEditable"
                    :is-deletable="attendance.isDeletable"
                    @cancel="$emit('cancelEdit')"
                    @attendanceUpdated="onUpdated(attendance.id, $event)"
                    @attendanceRemoved="onRemoved(attendance.id)"
                />

                <kgr-member-attendance-time-row
                    v-else
                    :key="attendance.id"
                    :start="attendance.start"
                    :end="attendance.end"
                    :is-current-day="isCurrentDay"
                    :is-editable="attendance.isEditable"
                    :is-deletable="attendance.isDeletable"
                    @edit="$emit('editAttendance', attendance.id)"
                />
            </template>
        </table>

        <kgr-button
            v-if="isCurrentDay && canCreateOrEditAttendances"
            :pending="actionPending"
            :type="buttonType"
            @click="$emit('actionTriggered')"
        >
            {{ buttonText }}
        </kgr-button>
    </div>
</template>

<script>
import KgrButton from '../../common/form/button/KgrButton';
import KgrMemberAttendanceTimeEditRow from './MemberAttendanceTimeEditRow';
import KgrMemberAttendanceTimeRow from './MemberAttendanceTimeRow';

export default {
    name: 'KgrMemberAttendanceAction',
    components: { KgrMemberAttendanceTimeEditRow, KgrMemberAttendanceTimeRow, KgrButton },
    props: {
        isCurrentDay: {
            type: Boolean,
            required: true,
        },
        attendances: {
            type: Array,
            required: true,
        },
        member: {
            type: Object,
            required: true,
        },
        pendingActions: {
            type: Array,
            required: true,
        },
        attendanceInEditMode: {
            type: String,
            required: false,
        },
        pendingAttendances: {
            type: Array,
            required: true,
        },
        canCreateOrEditAttendances: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        actionPending() {
            return this.pendingActions.includes(this.member.id);
        },
        hasOpenAttendance() {
            return this.attendances.filter(
                (attendance) => attendance.end === null,
            ).length > 0;
        },
        buttonText() {
            return this.hasOpenAttendance
                ? this.$t('Geht jetzt')
                : this.$t('Ist jetzt da');
        },
        buttonType() {
            return this.hasOpenAttendance
                ? 'red'
                : 'grey';
        },
    },
    methods: {
        onUpdated(attendanceId, timeRange) {
            this.$emit(
                'attendanceUpdated',
                {
                    attendanceId,
                    start: timeRange.start,
                    end: timeRange.end,
                },
            );
        },
        onRemoved(attendanceId) {
            this.$emit('attendanceRemoved', { attendanceId });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .action-entries > * {
    margin-top: 3px;
    margin-bottom: 3px;
}
</style>
